import { defineStore } from 'pinia'
import { useDeviceStore } from '@/stores/device'

// Add this function inside the store file (outside the store definition)
function generateRandomRoute(baseLat, baseLon) {
  // Generate a random route with 3-7 points that passes through the base position
  const numPoints = Math.floor(Math.random() * 5) + 4 // 4-8 points
  const route = []

  // Generate points before the ship's position
  const pointsBefore = Math.floor(Math.random() * (numPoints - 1)) || 1

  // Initial direction (random)
  let currentDirection = Math.random() * Math.PI * 2

  // Create points before ship position
  for (let i = 0; i < pointsBefore; i++) {
    // Generate points progressively approaching the ship
    const factor = (i + 1) / (pointsBefore + 1)
    // Limit direction change to maximum 30 degrees (converted to radians)
    const maxChange = (30 * Math.PI) / 180

    // Update direction with limited change
    currentDirection += Math.random() * 2 * maxChange - maxChange
    const distance = 0.5 - 0.4 * factor // Closer to ship as i increases

    route.push([baseLat + Math.sin(currentDirection) * distance, baseLon + Math.cos(currentDirection) * distance])
  }

  // Calculate direction to the ship's position
  if (route.length > 0) {
    const lastPoint = route[route.length - 1]
    const dx = baseLat - lastPoint[0]
    const dy = baseLon - lastPoint[1]
    currentDirection = Math.atan2(dx, dy)
  }

  // Add the ship's current position in the middle of the route
  route.push([baseLat, baseLon])

  // Create points after ship position
  for (let i = 0; i < numPoints - pointsBefore - 1; i++) {
    // Generate points progressively moving away from the ship
    const factor = (i + 1) / (numPoints - pointsBefore)
    // Limit direction change to maximum 30 degrees (converted to radians)
    const maxChange = (30 * Math.PI) / 180

    // Update direction with limited change
    currentDirection += Math.random() * 2 * maxChange - maxChange
    const distance = 0.1 + 0.4 * factor // Further from ship as i increases

    route.push([baseLat + Math.sin(currentDirection) * distance, baseLon + Math.cos(currentDirection) * distance])
  }

  return route
}

export const useUserStore = defineStore('user', {
  state: () => ({
    isShipsReady: false,
    isInstallationsReady: false,
    isAgreementInstallationsReady: false,

    ECDISList: [],
    installationsECDIS: [],
    installationsDevices: [],
    ordersByDevices: [{ id: 1, orders: 2 }],
  }),
  getters: {
    isShipsLoaded: state => state.isShipsReady,
    isInstallationsLoaded: state => state.isInstallationsReady,
    // getShipName: (state) => {
    //     let deviceStore = useDeviceStore()
    //     let deviceId = deviceStore.getDeviceID
    //
    //     let installation = state.installationsECDIS.find((a) => a.deviceId == deviceId)
    //     return installation?.primarInfo?.shipInfo?.name ?? ''
    // },

    getShipName: state => {
      let deviceStore = useDeviceStore()
      let deviceId = deviceStore.getDeviceID

      let installation = state.ECDISList.find(a => a.deviceId == deviceId)
      return installation?.shipName ?? ''
    },

    getECDISShips: state => {
      let installations = []
      state.ECDISList.forEach(item => {
        let status = Math.floor(Math.random() * 3)
        let agreementTypes = ['MSS Agreement', 'Primar GMS Agreement', 'No Agreement']
        let agreement = agreementTypes[Math.floor(Math.random() * agreementTypes.length)]

        // Generate a base position for the ship
        let baseLat = 56.0 + (Math.random() * 2 - 1)
        let baseLon = 3.0 + (Math.random() * 2 - 1)
        let latlng = [baseLat, baseLon]

        // Generate a random route with 3-7 waypoints that passes through the ship's position
        let route = generateRandomRoute(baseLat, baseLon)

        installations.push({
          value: item.deviceId,
          text: item.shipName,
          email: item.email,
          status: status,
          agreement: agreement,
          coordinates: latlng,
          route: route, // Add the route to the ship object
        })
      })

      return installations
    },

    // getShips: (state) => {
    //     let installations = []
    //     state.installationsECDIS.forEach(item => {
    //         installations.push({value: item.deviceId, text: item.shipName})
    //     })
    //     return installations
    // },
    // getAppTypeByDeviceID: (state) => {
    //     return (val) => state.installationsECDIS.find((a) => a.deviceId === val)?.applicationId
    // },
    // getInstallationByDeviceID: (state) => {
    //     return (val) => state.installationsECDIS.find((a) => a.deviceId === val)
    // },

    // Геттер для получения applicationId по deviceId
    getApplicationId: (state) => {
      return (deviceId) => {
        console.log('Searching for applicationId for deviceId:', deviceId)
        
        // Ищем в ECDISList
        const installation = state.ECDISList.find(item => item.deviceId === deviceId)
        if (installation && installation.applicationId) {
          console.log('Found applicationId in ECDISList:', installation.applicationId)
          return installation.applicationId
        }

        console.log('ApplicationId not found for deviceId:', deviceId)
        return '-1'
      }
    },
  },
  actions: {
    addECDISShips(payload) {
      let sortedList = payload.ecdisList.sort((a, b) => (a.shipName > b.shipName ? 1 : b.shipName > a.shipName ? -1 : 0))
      this.ECDISList = sortedList
      this.isShipsReady = true
    },
    addECDISAgreementShips(payload) {
      payload.ecdisList.forEach(item1 => {
        let index = this.ECDISList.findIndex(item2 => item1.deviceId == item2.deviceId)
        if (index !== -1) this.ECDISList.splice(index, 1)
      })

      let sortedList = payload.ecdisList.sort((a, b) => (a.shipName > b.shipName ? 1 : b.shipName > a.shipName ? -1 : 0))
      this.ECDISList.push(...sortedList)
      this.isAgreementInstallationsReady = true
      this.isShipsReady = true
    },
    addInstallations(payload) {
      this.installationsECDIS = payload.ecdisList
      this.installationsDevices = payload.devicesList
      this.isInstallationsReady = true
    },
    addOrders(payload) {
      this.ordersByDevices.push({ id: payload.id, orders: payload.orders })
    },
    reset() {
      this.isShipsReady = false
      this.isInstallationsReady = false
      this.isAgreementInstallationsReady = false
      this.ECDISList = []
      this.installationsECDIS = []
      this.installationsDevices = []
      this.ordersByDevices = [{ id: 1, orders: 2 }]
    },
  },
  persist: false,
})
